import { render, staticRenderFns } from "./NewsPost1.vue?vue&type=template&id=4a65aaca&"
import script from "./NewsPost1.vue?vue&type=script&lang=ts&"
export * from "./NewsPost1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports